module.exports = __webpack_public_path__ + "img/undraw_under_construction_46pa.196e914b.svg";